import { createContext } from "react";
import type { RoleContextType } from "./RoleContext.types";

const RoleContext = createContext<RoleContextType | undefined>(undefined);
RoleContext.displayName = "RoleContext";

export default RoleContext;
